// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from 'vue'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';


import App from './App'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Api from './request/api'
import {setCookie, getCookie, delCookie} from './assets/util.js'


console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV == 'production') {
    console.log(process.env.RELEASE_VERSION)
    Sentry.init({
      dsn:'http://0f32bde994eb43df8723bf0c11816443@10.244.11.37:9000/2',
      release: process.env.RELEASE_VERSION,
      integrations: [new Integrations.Vue({Vue, attachProps: true})],
    });
}

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$api = Api
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js